import React, {Component} from 'react';
import {AisinoCheckboxGroup, AisinoFormItem} from "../../../baseComponent/form";

class FormItemCheckboxGroup extends Component {
    render() {
        return (
            <AisinoFormItem {...this.props}>
                <AisinoCheckboxGroup  {...this.props} onChange={this.props.checkboxChange} onClick={this.props.checkboxClick}/>
            </AisinoFormItem>
        );
    }
}

export default FormItemCheckboxGroup;
